import { ListItem, ListItemProps, styled } from '@mui/material';
import { colors } from '@sweep-io/sweep-design';

interface ExtendedListItemProps extends ListItemProps {
  isSelected: boolean;
  isDisabled: boolean;
}

export const AgentMenuItem = styled(ListItem, {
  shouldForwardProp: (prop) => prop !== 'isSelected' && prop !== 'isDisabled',
})(({ isSelected, isDisabled }: ExtendedListItemProps) => ({
  paddingLeft: '8px',
  paddingRight: '8px',
  paddingTop: '4px',
  paddingBottom: '4px',
  minHeight: '32px',
  width: 'auto',
  borderRadius: '4px',
  marginBottom: 0,
  backgroundColor: isSelected ? colors.grey[150] : 'transparent',
  pointerEvents: isDisabled ? 'none' : undefined,
  '&:hover': {
    backgroundColor: isDisabled ? 'transparent' : colors.grey[150],
    cursor: isDisabled ? 'default' : 'pointer',
  },
}));
